import { DialogOnlyInformation } from 'components/DialogV3'
import React from 'react'
import { useTranslation } from 'react-i18next'

const DialogContactUs = (props) => {
    const { t } = useTranslation()
    
    return (
        <DialogOnlyInformation {...props} titleKey={'title.feedbackChannel'}>
            <div>
                <div className="icon-zalo">
                    <div className="contact-item-title">
                        <img
                            src={require('../assets/img/icons8-zalo.svg').default}
                            width={30}
                            alt=""
                        />
                        <div style={{ fontWeight: '700' }}>Zalo Viettel Solutions</div>
                    </div>
                    <div style={{ textAlign: 'justify' }}>{t('title.zaloVTS')}</div>
                </div>
            </div>
            <div>
                <div className="icon-tele">
                    <div className="contact-item-title">
                        <img
                            src={require('../assets/img/icons8-telegram-app.svg').default}
                            width={30}
                            alt=""
                        />
                        <div style={{ fontWeight: '700' }}>Telegram Viettel Solutions</div>
                    </div>
                    <div style={{ textAlign: 'justify' }}>{t('title.telegramVTS')}</div>
                </div>
            </div>
            <div>
                <div className="icon-web">
                    <div className="contact-item-title">
                        <img
                            src={require('../assets/img/icons8-website-48.png').default}
                            width={30}
                            alt=""
                        />
                        <div style={{ fontWeight: '700' }}>Website: MyViettel Enterprise</div>
                    </div>
                    <div style={{ textAlign: 'justify' }}>
                        {t('title.reportErrorWebsite')}
                        <span>
                            <a href="https://mve.viettel.vn">https://mve.viettel.vn</a>
                        </span>
                        {t('title.reportErrorWebsiteEnd')}
                    </div>
                </div>
            </div>
        </DialogOnlyInformation>
    )
}

export default DialogContactUs